// extracted by mini-css-extract-plugin
export default {"root":"InfoText_root__c7E4V","itemSkeleton":"InfoText_itemSkeleton__xkUdP"};